import { useMutation } from "@tanstack/react-query";
import { handleMutationError } from "@/utils/error";
import { customerEdit } from "@/requests/contract/customerEdit";

export const useCustomerEditMutation = (uuid: string) => {
  return useMutation({
    mutationFn: (note: string) => customerEdit(uuid, note),
    onError: handleMutationError,
  });
};
